<template>
  <div class="news">
    <el-row>
      <el-col :span="2">&nbsp;</el-col>
      <el-col :span="20">
        <ul class="newsList">
          <li
            v-for="(item,index) in newsList"
            @click="$router.push({path:'/newsDetail',query:{id:item.id,name:name}})"
          >
            <div class="newsL">
              <img :src="settings.apiBaseImg+item.img" alt="news" />
            </div>
            <div class="newsC">
              <p class="newsTitle">{{item.name}}</p>
              <p class="newsDesc">{{item.describe}}</p>
            </div>
            <div class="newsR">
              <p>{{item.create_date_tian}}</p>
            </div>
          </li>
        </ul>
        <div class="more">
          <el-pagination
            background
            layout="prev, pager, next"
            :total="total"
            :page-size="pageSize"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          ></el-pagination>
        </div>
      </el-col>
      <el-col :span="2">&nbsp;</el-col>
    </el-row>
  </div>
</template>

<script>
import request from "../../assets/js/request.js";
import qs from "qs";
export default {
  data() {
    return {
      newsList: [],
      id: 1,
      name: "",
      currentPage: 1,
      pageSize: 6,
      total: 0,
    };
  },
  created() {
    this.getData(this.id, "", this.currentPage, this.pageSize);
  },
  methods: {
    getData(id, name, currentPage, pageSize) {
      if (name == undefined) {
        this.name = "公司要闻";
      } else {
        this.name = name;
      }
      request
        .post(
          this.settings.apiBaseUrl + "/api/index/news_list",
          qs.stringify({
            type: id,
            page: currentPage,
            pagesize: pageSize,
          }),
          {
            headers: {},
          }
        )
        .then((res) => {
          if (res.code == 1) {
            this.newsList = res.data.rows;
            this.total = res.data.total;
            console.log(this.total);
          } else {
            this.$message.error(res.msg);
          }
        });
    },
    handleSizeChange(val) {
      this.pageSize = val; //将每页显示的条数 = 改变的值
      this.getData(this.id, name, this.currentPage, this.pageSize);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getData(this.id, name, this.currentPage, this.pageSize);
    },
  },
};
</script>

<style scoped="scoped">
.news {
  width: 100%;
  height: auto;
}

.newsList li {
  width: 100%;
  height: 250px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
  padding: 20px 0 26px 20px;
  cursor: pointer;
}

.newsList li:hover {
  background-image: url(../../assets/images/news/newb.png);
  background-size: 100% 100%;
}

.newsList li:hover .newsC .newsTitle {
  color: #ffffff !important;
}

.newsList li:hover .newsC .newsDesc {
  color: #ffffff !important;
}

.newsList li:hover .newsR p {
  color: #ffffff !important;
}

.newsList .newsL {
  width: 25%;
  height: 100%;
  float: left;
  box-sizing: border-box;
}

.newsList .newsL img {
  width: 100%;
  height: 100%;
}

.newsList .newsC {
  width: 65%;
  height: 100%;
  float: left;
  box-sizing: border-box;
  padding: 45px;
}

.newsList .newsR {
  padding-top: 45px;
  width: 8%;
  height: 100%;
  float: left;
  box-sizing: border-box;
}

.newsC .newsTitle {
  height: 30px;
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #252525;
  line-height: 29px;
  margin-bottom: 45px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.newsC .newsDesc {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #8c8c8c;
  line-height: 22px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
}

.newsR p {
  height: 22px;
  font-size: 30px;
  font-family: Arial;
  font-weight: bold;
  color: #cccccc;
}
</style>



// WEBPACK FOOTER //
// src/components/news/news.vue